module.exports = __webpack_public_path__ + "img/upload-file.94a6f4ce.svg";